import { initSingleReviewControls } from "./review_single.js";

interface PC_SP_ReviewRespons {
    max_num_pages: number;
    html: string;
}


function initReviewsSearchFilter(container:HTMLDivElement, onChange:Function, onEnter?:Function) {
    const searchInput = container.querySelector('.pc_sp_review_searchbox_input') as HTMLInputElement;
    const reviewSearchForm = container.querySelector('.pc_sp_review_search_form') as HTMLFormElement;
    const sortBySelect = container.querySelector('.pc_sp_review_sorting_select') as HTMLSelectElement;
    const nStarsSelect = container.querySelector('.pc_sp_review_filter_select') as HTMLSelectElement;
    const clearFiltersButton = container.querySelector('.pc_sp_review_clear_filters_button') as HTMLButtonElement;
    
    // states
    let searchQuery:string = searchInput.value;
    let sortBy:string = sortBySelect.value;
    let nStars:string = nStarsSelect.value;

    // event listeners
    searchInput.addEventListener('input', () => {
        searchQuery = searchInput.value.trim();
    });

    // enter key event for search input
    /*searchInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (searchQuery.trim() === '') {
                searchQuery = '';
            }
            if (onEnter) {
                onEnter({ searchQuery, sortBy, nStars });
            }
        }
    });*/

    sortBySelect.addEventListener('change', () => {
        sortBy = sortBySelect.value;
        onChange({ searchQuery, sortBy, nStars });
    });

    nStarsSelect.addEventListener('change', () => {
        nStars = nStarsSelect.value;
        onChange({ searchQuery, sortBy, nStars });
    });

    clearFiltersButton.addEventListener('click', (event) => {
        event.preventDefault();
        searchQuery = '';
        sortBy = 'most_relevant';
        nStars = 'all';
        searchInput.value = '';
        sortBySelect.value = sortBy;
        nStarsSelect.value = nStars;
        onChange({ searchQuery, sortBy, nStars });
    });

    reviewSearchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        onChange({ searchQuery, sortBy, nStars });
    });
}

function reviewManager() {
    // components
    const searchContainer = document.querySelector('.pc_sp_review_search_container') as HTMLDivElement;
    if (!searchContainer) return;

    

    const reviewsContainer = searchContainer.querySelector('.reviews_container') as HTMLDivElement;
    const loadMoreButton = document.querySelector('.pc_sp_show_more_reviews_btn') as HTMLButtonElement;
    const searchResultsText = searchContainer.querySelector('.pc_sp_reviwe_search_results_text') as HTMLDivElement;

    const ajaxUrl = loadMoreButton.getAttribute('data-ajax-url') || '';
    if (!ajaxUrl) {
        console.error('No AJAX URL found for loading reviews.');
        return;
    }
    const postID = loadMoreButton.getAttribute('data-post-id') || '';
    if (!postID) {
        console.error('No post ID found for loading reviews.');
        return;
    }

    const ajaxAction = "pc_sp_get_reviews";
    let currentPage = 1;
    let perPage = parseInt(loadMoreButton.getAttribute('data-per-page') || '5', 10);

    const loadReviews = (filters:any, append:boolean = true) => {
        const data = {
            action: ajaxAction,
            perks_id: postID,
            paged: currentPage,
            per_page: perPage,
            search_query: filters.searchQuery || '',
            sort_by: filters.sortBy || 'most_relevant',
            n_stars: filters.nStars || 'all'
        };
        const fd = new FormData();
        (Object.keys(data) as Array<keyof typeof data>).forEach((key) => {
            fd.append(key, String(data[key]));
        });

        let buttonText = loadMoreButton.innerHTML;
        loadMoreButton.innerHTML = 'Loading...';
        loadMoreButton.setAttribute('disabled', 'true');

        fetch(ajaxUrl, {
            method: 'POST',
            body: fd
        })
        .then(response => response.json())
        .then((data: any) => {
            let rsp = data.data as PC_SP_ReviewRespons;
            if (rsp){
                if (append === true){
                    reviewsContainer.innerHTML += rsp.html;
                } else {
                    reviewsContainer.innerHTML = rsp.html;
                }
                initSingleReviewControls();
                if (currentPage >= rsp.max_num_pages) {
                    loadMoreButton.style.display = 'none';
                }

                // if pc_sp_reviwe_search_results_text
                if (filters.searchQuery && searchResultsText) {
                    searchResultsText.style.display = 'block';
                    searchResultsText.textContent = `Showing results for "${filters.searchQuery}"`;
                } else {
                    searchResultsText.style.display = 'none';
                }
            }
        })
        .catch(error => console.error('Error loading reviews:', error))
        .finally(() => {
            loadMoreButton.innerHTML = buttonText;
            loadMoreButton.removeAttribute('disabled');
        });
    };

    loadMoreButton.addEventListener('click', () => {
        currentPage++;
        loadReviews({});
    });

    initReviewsSearchFilter(searchContainer, (filters:any) => {
        currentPage = 1; // Reset to first page
        loadReviews(filters, false); 
    });

    initSingleReviewControls();
}

export function initReviewsHandler() {
    reviewManager();
}